import { useCallback, useEffect } from 'react';
import { Query } from '../fetch/useQuery';
import useTimeout from './useTimeout';

const usePollingQuery = <T,>(query: Query<T>, intervalMs: number) => {
  const pollingTimeout = useTimeout(() => { }, intervalMs);

  const startQuery = useCallback(() => {
    query.query();
    pollingTimeout.restart();
  }, [query, pollingTimeout]);

  useEffect(() => {
    if (!query.isLoading && !pollingTimeout.isRunning) {
      startQuery();
    }
  }, [query.isLoading, startQuery, pollingTimeout]);
};

export default usePollingQuery;